(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('BibliotecaDetailsController', BibliotecaDetailsController);

    /* @ngInject */
    function BibliotecaDetailsController($timeout, $stateParams) {
        var vm = this;

        vm.esBuscadorBasico = true;
        // console.log(vm.esBuscadorBasico);

        vm.pagina = $stateParams.page ? $stateParams.page : 1;
    }

})(angular);
